import { createActions } from 'reduxsauce';

export const { Types: NullBelegTypes, Creators: NullBelegActionCreators } =
    createActions({
        printNullBelegStart: ['body'],
        printNullBelegSuccess: ['data'],
        printNullBelegFailure: ['error'],
        printTicketStart: ['data'],
    });
